import React, { Component } from 'react';
import Select from 'react-select';

import statesList from 'constants/AmericanStates';
import 'assets/scss/soonoGetStarted.css';
import SignUpWrapper from 'containers/SignUpWrapper';
import { checkValidity, handleFormValidate } from 'utils/formvalidate';
import {
  TRIAL_SIGNUP_ROUTES,
  ROUTES,
  ONBOARDING_ROUTES,
} from 'constants/Routes';
import { FREE_SIGNUP_STEPS } from 'constants/Transactions';
import MultiSelectField from 'components/businesses/MultiSelectField';
import BusinessApi from 'apis/Business';
import {
  getContactDetails,
  removeContactDetails,
  getBusinessDetails,
  setBusinessDetails,
  getOnboardingStatus,
  setOnboardingStatus,
  setToken,
  setUserId,
  setBusinessId,
  setRole,
  setDashboardMetricObject,
  removeBusinessDetails,
  getToken,
  getBillingDetails,
  getNonce,
  setConfirmationGracePeriod,
  setConfirmed,
  getSelectedPlan,
  setBusinessPlan,
  setUserData,
} from 'constants/localStorageManager';
import AuthApi from 'apis/Auth';
import UsersApi from 'apis/Users';
import Loading from 'utils/Loading';

import Toaster from '../Toaster';
import InputField from './InputField';

const assignFormValuetoKeys = formValues => {
  const formKeys = Object.keys(formValues);
  const formData = {};

  formKeys.forEach(key => {
    formData[key] = formValues[key].value;
  });

  return formData;
};

class TrialBusinessDetails extends Component {
  constructor() {
    super();
    this.state = {
      formValues: {
        addressLine1: {},
        addressLine2: {},
        businessCategory: {},
        businessDescription: {},
        businessName: {},
        businessWebsite: {},
        city: {},
        state: {},
        zip: {},
      },
      isOnboarded: false,
    };
  }

  componentDidMount() {
    this.checkOnboarding();
    this.prefillBillingDetails();
  }

  prefillBillingDetails = () => {
    const { formValues } = this.state;
    const billingDetails = getBillingDetails() || {};
    const formFields = ['addressLine1', 'addressLine2', 'state', 'zip', 'city'];
    const _formValues = {};
    formFields.forEach(
      key => (_formValues[key] = { value: billingDetails[key] })
    );
    this.setState({ formValues: { ...formValues, ..._formValues } });
  };

  checkOnboarding = () => {
    const onboardingStatus = getOnboardingStatus() || {};
    this.setState({ isOnboarded: onboardingStatus.completed });
  };

  handleSubmit = e => {
    e.preventDefault();
    const form = this.refs.businessForm;
    const { hasErrors, formValues } = handleFormValidate(form);
    const hasValidCategories = !this.validateCategorySelection();
    const hasValidState = !this.validateStateSelection();
    const updatedFormValues = { ...this.state.formValues, ...formValues };

    this.setState({ hasErrors, formValues: updatedFormValues });
    if (!hasErrors && hasValidCategories && hasValidState)
      this.updateBusinessDetails();
  };

  getBillingAddressAttributes = () => {
    const { phone_number } = getContactDetails();
    const {
      addressLine1: address_line_1,
      addressLine1: address_line_2,
      city,
      state,
      zip,
      country,
    } = getBillingDetails() || {};
    const { nonce, billing_name } = getNonce() || {};
    if (!nonce) return;
    return {
      address_line_1,
      address_line_2,
      city,
      state,
      zip,
      country,
      phone_number,
      billing_name,
      nonce,
      is_primary: true,
    };
  };

  updateBusinessDetails = () => {
    const { location } = this.props;
    const { formValues } = this.state;
    const businessDetails = assignFormValuetoKeys(formValues);
    const {
      addressLine1: address_line_1,
      addressLine2: address_line_2,
      businessCategory: category_ids,
      businessDescription: description,
      businessName: name,
      businessWebsite: website,
      city,
      state,
      zip,
    } = businessDetails;

    const {
      id: user_id,
      first_name,
      last_name,
      email,
      phone_number,
    } = getContactDetails();

    const currentDate = new Date();
    const endDateInUnix = currentDate.setDate(currentDate.getDate() + 7);
    const endDate = new Date(endDateInUnix);
    const billing_addresses_attributes = [this.getBillingAddressAttributes()];
    const plan_subscription_attributes = getSelectedPlan();

    const businessData = {
      business: {
        address_line_1,
        address_line_2,
        category_ids,
        description,
        name,
        website,
        city,
        state,
        zip,
        plan_subscription_attributes,
        contact_attributes: {
          first_name,
          last_name,
          email,
          primary_number: phone_number,
        },
        business_users_attributes: [
          {
            role: 'admin',
            user_id,
          },
        ],
        billing_addresses_attributes,
      },
    };
    BusinessApi.addNew(businessData)
      .then(({ data }) => {
        setBusinessDetails(data);
        setOnboardingStatus({ completed: true });
        this.login();
      })
      .catch(() => {
        Toaster.getErrorToaster('exclamation-triangle', 'Something went wrong');
      });
  };

  login = () => {
    const token = getToken();
    if (!token) {
      const { email, password } = getContactDetails();
      AuthApi.login(email, password).then(response => {
        this.setState({ isOnboarded: true });
        const token = response.headers.authorization;
        setToken(token);
        const {
          id,
          business,
          role,
          dashboard,
          confirmation_grace_period,
          confirmed,
          plan,
        } = response.data;
        setUserId(id);
        setBusinessId(business.id);
        setRole(role);
        setConfirmationGracePeriod(confirmation_grace_period);
        setConfirmed(confirmed);
        setDashboardMetricObject(dashboard);
        setBusinessPlan(plan);
        setUserData(response.data);
        this.handleContinue();
      });

      return;
    }

    UsersApi.getDetails().then(({ data }) => {
      this.setState({ isOnboarded: true });
      const { id, business, role, dashboard } = data;
      setUserId(id);
      setBusinessId(business.id);
      setRole(role);
      setDashboardMetricObject(dashboard);
      this.handleContinue();
    });
  };

  changeStep = currentPathName => {
    const currentStepObj = FREE_SIGNUP_STEPS.find(
      step => step.path == currentPathName
    );
    const currentStepNumber = FREE_SIGNUP_STEPS.indexOf(currentStepObj);
    const lastStep = currentStepNumber == FREE_SIGNUP_STEPS.length - 1;
    if (lastStep) return this.props.history.push(ROUTES.DASHBOARD_INDEX);
    const nextStep = FREE_SIGNUP_STEPS[currentStepNumber + 1];
    this.props.history.push(nextStep.path);
  };

  handleChange = e => {
    const { name, value, required, type } = e.target;
    const _state = { ...this.state };
    const hasError = checkValidity({ name, value, type, required });
    _state.formValues[name] = {
      value,
      hasError,
    };

    this.setState({ ..._state });
  };

  handleSelectChange = e => {
    const { formValues } = this.state;
    const businessCategory = {};
    businessCategory.value = e ? e.split(',') : [];

    this.setState({ formValues: { ...formValues, businessCategory } });
  };

  handleStateChange = e => {
    const { formValues } = this.state;
    const state = {};
    state.value = e ? e.value : null;

    this.setState({ formValues: { ...formValues, state } });
  };

  validateStateSelection = () => {
    const { formValues } = this.state;
    const { state } = formValues;
    let hasError = true;
    if (state.value) {
      hasError = false;
    }
    state.hasError = hasError;

    this.setState({ formValues: { ...formValues, state } });
    return hasError;
  };

  validateCategorySelection = () => {
    const { formValues } = this.state;
    const { businessCategory } = formValues;
    let hasError = true;
    if (businessCategory.value && businessCategory.value.length > 0) {
      hasError = false;
    }
    businessCategory.hasError = hasError;

    this.setState({ formValues: { ...formValues, businessCategory } });
    return hasError;
  };

  handleSelectBlur = e => {
    this.validateCategorySelection();
  };

  handleStateSelectBlur = () => {
    this.validateStateSelection();
  };

  handleContinue = () => {
    const { id } = getBusinessDetails();
    removeContactDetails();
    removeBusinessDetails();
    this.props.history.push(ONBOARDING_ROUTES.STEP_ONE);
  };

  render() {
    const { onChange, location } = this.props;
    const { formValues, isOnboarded } = this.state;
    const { businessCategory, state } = formValues;
    const { value, hasError } = businessCategory;

    if (isOnboarded) {
      return <Loading />;
    }

    return (
      <SignUpWrapper
        step={TRIAL_SIGNUP_ROUTES.BUSINESS_DETAILS}
        currentStep={location.pathname}
      >
        <div className="col-md-10 offset-md-1">
          <h3 className="mt-5 mb-2 text-dark" style={{ fontWeight: 600 }}>
            Tell us a little bit about your business
          </h3>
          <p className="text-dark">
            We'll get you going right after this final step!
          </p>
          <form
            ref="businessForm"
            className="form mt-4 mb-5 text-left text-dark soono-transaction-form"
          >
            <div className="form-group mb-3">
              <InputField
                formValues={formValues}
                type="text"
                label="Business Name"
                placeholder=""
                name="businessName"
                handleChange={this.handleChange}
                required
              />
            </div>
            <div class="form-group">
              <InputField
                formValues={formValues}
                type="textarea"
                label="Short business description"
                placeholder=""
                name="businessDescription"
                handleChange={this.handleChange}
                required
              />
            </div>
            <div className="row">
              <div className="form-group col">
                <InputField
                  formValues={formValues}
                  type="url"
                  label="Business Website"
                  placeholder=""
                  name="businessWebsite"
                  handleChange={this.handleChange}
                  required
                />
              </div>
              <div class="form-group col">
                <label for="businessCategory">Category of your business</label>
                <MultiSelectField
                  handleSelectChange={this.handleSelectChange}
                  className="form-control py-3 pl-4 pr-4 trial-multi-select"
                  value={value}
                  name="category"
                  ref="category"
                  handleFocusOutCategory={this.handleSelectBlur}
                />
                {hasError && (
                  <div className="row error" id="categoryError">
                    Please select atleast one category
                  </div>
                )}
              </div>
            </div>
            <hr className="mb-3"></hr>
            <div className="row">
              <div className="form-group col">
                <InputField
                  formValues={formValues}
                  type="address"
                  label="Address Line 1"
                  placeholder=""
                  name="addressLine1"
                  handleChange={this.handleChange}
                  required
                />
              </div>
              <div class="form-group col">
                <InputField
                  formValues={formValues}
                  type="address"
                  label="Address Line 2"
                  placeholder=""
                  name="addressLine2"
                  handleChange={this.handleChange}
                />
              </div>
            </div>
            <div className="row">
              <div className="form-group col">
                <InputField
                  formValues={formValues}
                  type="text"
                  label="City"
                  placeholder=""
                  name="city"
                  handleChange={this.handleChange}
                  required
                />
              </div>
              <div class="form-group col state-select">
                <label for="state">State</label>
                <Select
                  name="state"
                  className="section"
                  options={statesList}
                  onChange={this.handleStateChange}
                  onBlur={this.handleStateSelectBlur}
                  value={state.value}
                  removeSelected
                  isClearable={false}
                  required
                />
                {state.hasError && (
                  <div className="row error" id="categoryError">
                    State is required
                  </div>
                )}
              </div>
              <div class="form-group col">
                <InputField
                  formValues={formValues}
                  type="zip"
                  label="Zip"
                  placeholder=""
                  name="zip"
                  handleChange={this.handleChange}
                  required
                />
              </div>
            </div>
            <br></br>
            <div className="form-group">
              <button
                className="btn-warning btn-lg col-md-4 offset-md-4 py-3 pl-5 pr-5 text-white text-bold border-0 cursor-pointer"
                type="button"
                onClick={this.handleSubmit}
              >
                Finish
              </button>
            </div>
          </form>
        </div>
      </SignUpWrapper>
    );
  }
}

export default TrialBusinessDetails;



// WEBPACK FOOTER //
// ./src/components/transactions/TrialBusinessDetails.js